<div class="shift-content my-20" fusePerfectScrollbar>
    <div class="container">
        <div class="content-header">
            <div class="h2 secondary-text">
                {{'ADDED_CONTAINERS'|translate}}
            </div>
            <hr>
        </div>
        <div fxLayout="column">

            <div class="shify-container-list-item" *ngFor="let item of containerList">
                <mat-label class="shify-container-list-label">{{'CONTAINER_ADDRESS'|translate}}: </mat-label>
                <span>{{item.container.streetDesc!=null?item.container.streetDesc:'---'}}</span>
            </div>
        </div>
    </div>
</div>